import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-class"
export default class extends Controller {
  static targets = ['item']
  static classes = ['toggle']
  static values = {
    toggleSelf: { type: Boolean, default: true }
  }

  declare readonly itemTargets: HTMLElement[]
  declare readonly toggleClass: string
  declare readonly toggleSelfValue: boolean

  connect() {
    if (this.itemTargets.length > 0)
      this.itemTargets[0].classList.add(this.toggleClass)
  }

  toggle(event) {
    this.itemTargets.forEach(itemTarget => {
      itemTarget.classList.remove(this.toggleClass)
    });
    if(this.toggleSelfValue) {
      event.currentTarget.classList.add(this.toggleClass)
    }
  }
}
